import { forwardRef } from 'react';
import MDTypographyRoot from 'components/MDTypography/MDTypographyRoot';
import { useMaterialUIController } from 'context';

const BillzTypographyTitle = forwardRef(
  ({ color, fontWeight, textTransform, verticalAlign, textGradient, opacity, children, ...rest }, ref) => {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    return (
      <MDTypographyRoot
        {...rest}
        ref={ref}
        sx={{ fontSize: '18px', color: '#344767', fontWeight: '700', fontFamily: 'Roboto,Helvetica' }}
        ownerState={{
          color,
          textTransform,
          verticalAlign,
          fontWeight,
          opacity,
          textGradient,
          darkMode,
        }}
      >
        {children}
      </MDTypographyRoot>
    );
  },
);

export default BillzTypographyTitle;
